import { t, Trans } from '@lingui/macro';
import { DocumentRequirement } from 'components/Signup/TradingHistory/DocumentRequirement/DocumentRequirement';
import { TOfferDataRequirement } from 'lendingApi/lapiOverrides.types';

type TProps = {
  isOptional: boolean;
  isSubmitted: boolean;
  status?: TOfferDataRequirement['actions'][number]['status'];
};

export const BankStatements = ({ isOptional, isSubmitted, status }: TProps) => {
  return (
    <DocumentRequirement
      title={t`Business bank statements from the last 3 months`}
      documentType="bank statement"
      isOptional={isOptional}
      isSubmitted={isSubmitted}
      status={status}
    >
      <>
        <p>
          <Trans>Manually upload account statements as PDF</Trans>
        </p>
        <ul>
          <li>
            <Trans>
              You can download the account statements from your online banking
            </Trans>
          </li>
          <li>
            <Trans>
              Upload the sales in PDF format with complete booking text
            </Trans>
          </li>
          <li>
            <Trans>Each file can be a maximum of 50MB in size</Trans>
          </li>
          <li>
            <Trans>
              Make sure the files are not password protected (or share the
              password with us)
            </Trans>
          </li>
        </ul>
      </>
    </DocumentRequirement>
  );
};
